import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { gql } from 'graphql-request'

import { useQuery } from '@hooks/graphql'
import Spinner from '@components/Spinner'
import Pagination from '@components/Pagination'
import CourseCard from './CourseCard'

import NoResults from './NoResults'
import SegmentedControl from '../../../../components/SegmentedControl'

const CLASSROOM_ASSIGNMENTS_QUERY = gql`
  query classroomAssignments($id: ID!, $page: Int, $closed: Boolean) {
    classroom(id: $id) {
      seriesAssignments(page: $page, perPage: 8, closed: $closed) {
        nodes {
          id
          createdAt
          closed
          startDate
          dueDate
          currentTime
          series {
            id
            name
            description
            coverImage {
              url
            }
          }
        }
        pagesCount
        nodesCount
      }
    }
  }
`


const CoursesList = ({ id }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const page = searchParams.get('page') || 1
  const status = searchParams.get('status') || 'open'

  const { isLoading, data: { classroom: { seriesAssignments: { nodes: assignments = [], pagesCount, nodesCount } = {} } = {} } = {} } = useQuery({
    queryKey: ['classroomAssignments', id, page, status],
    gqlQuery: CLASSROOM_ASSIGNMENTS_QUERY,
    variables: { id, page: parseInt(page), closed: status ? status === 'closed' : null }
  })

  const setPage = page => {
    if (status === null) {
      setSearchParams({ page })
    } else {
      setSearchParams({ page, status })
    }
  }

  return (
    <div className='px-5 pt-4'>
      <SegmentedControl
        className='mb-4'
        options={[
          { label: 'Active', value: 'open' },
          { label: 'Closed', value: 'closed' }
        ]}
        value={status}
        onChange={value => {
          setSearchParams({ status: value })
        }}
      />

      <Choose>
        <When condition={isLoading}>
          <Spinner className='flex items-center justify-center w-full h-full' />
        </When>

        <When condition={nodesCount === 0}>
          <NoResults status={status} />
        </When>

        <Otherwise>
          <div className='flex flex-wrap gap-5'>
            <For index='index' each='assignment' of={assignments}>
              <With course={assignment.series}>
                <CourseCard
                  key={course.id}
                  courseId={course.id}
                  name={course.name}
                  description={course.description}
                  imageUrl={course.coverImage?.url}
                  startDate={assignment.startDate}
                  dueDate={assignment.dueDate}
                  currentTime={assignment.currentTime}
                  isClosed={assignment.closed}
                  fullCourseData={course}
                  className='w-full md:w-[calc(33.333%-14px)]'
                />
              </With>
            </For>
          </div>

          <Pagination page={parseInt(page)} pagesCount={pagesCount} setPage={setPage} />
        </Otherwise>
      </Choose>
    </div>
  )
}

export default CoursesList
